import React, { useState } from "react";
import Slideover from "../Slideover/Slideover";
// import { useSession } from "../../contexts/SessionContext";

/**
 * Componente simplificado de contato para reportar problemas ou sugerir melhorias.
 *
 * @component
 * @returns {JSX.Element} O componente de instruções de contato.
 */
export default function ReportForm() {
  const [showForm] = useState(true);
  // const { sessionId, username, firebaseUserId } = useSession();

  if (!showForm) return null;

  return (
    <Slideover title={"Fale Conosco"}>
      <div className="space-y-12">
        <div className="border-b border-slate-900/10">
          <p className="mt-1 text-sm leading-6 select-none text-slate-600 dark:text-slate-200">
            Formulário para reportar problemas ou sugerir melhorias.
          </p>

          <div className="mt-4 border border-slate-300 dark:border-slate-700 rounded-md p-4 text-sm text-slate-600 dark:text-slate-200">
            <p className="mb-2">
              Para reportar problemas ou sugerir melhorias, escreva seu
              comentário de forma clara e detalhada, enviando para:
            </p>
            <p className="font-semibold">atendimento@rnp.br</p>
          </div>
        </div>
      </div>
    </Slideover>
  );
}

